import {Splide} from '@splidejs/splide';

export default class ModelPageSlider {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        var header_element = document.querySelector('.model-header-slider');
        var thumbnail_element = document.querySelector('.model-slider');
        if (header_element && thumbnail_element) {
            var header_splide = new Splide(header_element, {
                'type': 'loop',
                'autoplay': false,
                'pagination': false,
            });
            let options = {
                'type': 'loop',
                'lazyLoad': 'nearby',
                'gap': '2rem',
                'mediaQuery': 'min',
                'isNavigation': true,
                'pagination': false,
                'breakpoints': {
                    '768': {
                        'perPage': 3,
                    }
                }
            }
            let slides = thumbnail_element.querySelectorAll('.splide__slide');
            if (slides.length < 4) {
                options['pagination'] = false;
            }
            // if (slides.length <= 3) {
            //     options['arrows'] = false;
            // }
            const thumbnail_splide = new Splide(thumbnail_element, options);
            if (slides.length < 3) {
                header_splide.mount();
                thumbnail_element.style.display = 'none';
            } else {
                header_splide.sync(thumbnail_splide);
                header_splide.mount();
                thumbnail_splide.mount();
            }
        }
    }
}